// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'amfe-flexible'
import "../static/css/public.css";
import ElementUI from 'element-ui';
//这个按需引入的时候也需要导入样式才生效（虽然文档没引入）
import 'element-ui/lib/theme-chalk/index.css';
import global from "../static/js/utils";
import api from "../static/js/api";

Vue.use(ElementUI);

Vue.prototype.$global = global; // 全局定义配置文件
Vue.prototype.$api = api; // 全局定义配置api


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js